import React from 'react';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { Icon } from '@livable/saas-react-components';
import { Typography, Button, Grid } from '@mui/material';
// import PostChargeModal from 'src/components/resident/PostChargeModal';
import { BatchPostChargeModal } from 'src/components/unit/BatchPostChargeModal';
import { DateChangeInlineModal } from 'src/components/unit/DateChangeInlineModal';
import { BatchDueReminderModal } from 'src/components/unit/BatchDueReminderModal';
import { BatchOccupancyUpdatesModal } from 'src/components/unit/BatchOccupancyUpdatesModal';
// import { tenantsArray } from 'src/configs/sampleData';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
export const ActiveTenantsActions = observer(() => {
  var _store$homeDashboardS2, _store$homeDashboardS3, _store$homeDashboardS4, _store$homeDashboardS5;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const selectedDetails = store.residenciesMultiActionStore.selectedDetails;
  const isConvergentSelection = store.account.featureFlagsStore.getIsConvergentBillingEnabled && !store.company.companyFeatureStore.isAppfolio && selectedDetails.length > 0 && selectedDetails.every(detail => {
    var _store$homeDashboardS, _dashboard$convergent;
    if (!detail.propertyId) {
      return false;
    }
    const dashboard = (_store$homeDashboardS = store.homeDashboardStore.getPropertyById(detail.propertyId)) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.dashboard;
    if (!dashboard) {
      return false;
    }
    return (_dashboard$convergent = dashboard.convergentBillingModeOverride) !== null && _dashboard$convergent !== void 0 ? _dashboard$convergent : store.company.companyFeatureStore.convergentBillingMode;
  });
  const showDueReminder = (!store.company.companyFeatureStore.disableBatchSendReminder || !((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS2 !== void 0 && (_store$homeDashboardS2 = _store$homeDashboardS2.companyFeatureSet) !== null && _store$homeDashboardS2 !== void 0 && _store$homeDashboardS2.disableBatchSendReminder)) && !isConvergentSelection;
  const trigger = (title, type) => /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '231-activeTenantsActions'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: type
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, title));
  return /*#__PURE__*/React.createElement("div", {
    className: classes.actionsWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Batch actions:"), /*#__PURE__*/React.createElement("div", {
    className: classes.desktopActions
  }, /*#__PURE__*/React.createElement(DateChangeInlineModal, null), (!store.company.companyFeatureStore.disableBatchOccupancyChange || !((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS3 !== void 0 && (_store$homeDashboardS3 = _store$homeDashboardS3.companyFeatureSet) !== null && _store$homeDashboardS3 !== void 0 && _store$homeDashboardS3.disableBatchOccupancyChange)) && /*#__PURE__*/React.createElement(BatchOccupancyUpdatesModal, null), /*#__PURE__*/React.createElement(BatchPostChargeModal, null), showDueReminder && /*#__PURE__*/React.createElement(BatchDueReminderModal, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.tabletActions
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 7,
    rowSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(DateChangeInlineModal, {
    trigger: trigger("Update ".concat((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS4 !== void 0 && _store$homeDashboardS4.companyFeatureSet.isAppfolio ? t('billing start date') : t('residencies_page.enrolled_date_cell').toLocaleLowerCase()), 'calendar-picker')
  })), (!store.company.companyFeatureStore.disableBatchOccupancyChange || !((_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS5 !== void 0 && (_store$homeDashboardS5 = _store$homeDashboardS5.companyFeatureSet) !== null && _store$homeDashboardS5 !== void 0 && _store$homeDashboardS5.disableBatchOccupancyChange)) && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(BatchOccupancyUpdatesModal, {
    trigger: trigger('Occupancy change', 'group')
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(BatchPostChargeModal, {
    trigger: trigger('Post charge or credit', 'coin')
  })), showDueReminder && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(BatchDueReminderModal, {
    trigger: trigger('Send due reminder', 'warning')
  })))));
});